import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import CgmModulePageLayout from './layout/CgmModulePageLayout';
import './CgmFilterToolbar.css';
import './CgmModulePage.css';
import EtatCgmModal from './EtatCgmModal';
import { getActiveCaisseYear, buildCaisseYearOptions } from '../utils/caisseActiveYear';

export default function EtatClientByYearPage() {
  const { id } = useParams();
  const [tab, setTab] = useState('annee');
  const [jourMode, setJourMode] = useState('date');
  const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().split('T')[0]);
  const [dateDebut, setDateDebut] = useState('');
  const [dateFin, setDateFin] = useState('');
  const now = new Date();
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(() => getActiveCaisseYear());
  const [showModal, setShowModal] = useState(false);
  const [client, setClient] = useState(null);
  const years = buildCaisseYearOptions();

  useEffect(() => {
    fetchClientData();
  }, [id]);

  const fetchClientData = async () => {
    try {
      const response = await fetch(`/api/clients/${id}`);
      const data = await response.json();
      if (data.success) setClient(data.client);
    } catch (error) {
      console.error('Erreur client:', error);
    }
  };

  const handleShowEtat = () => {
    let finalFilterType = tab;
    let finalDate = null;
    let finalDateDebut = null;
    let finalDateFin = null;
    let finalMois = null;
    let finalAnnee = null;

    if (tab === 'jour') {
      if (jourMode === 'date') {
        if (!selectedDate) {
          alert('Veuillez sélectionner une date');
          return;
        }
        finalDate = selectedDate;
      } else {
        if (!dateDebut || !dateFin) {
          alert('Veuillez sélectionner une période (début et fin)');
          return;
        }
        if (new Date(dateDebut) > new Date(dateFin)) {
          alert('La date de début doit être antérieure à la date de fin');
          return;
        }
        finalFilterType = 'periode';
        finalDateDebut = dateDebut;
        finalDateFin = dateFin;
      }
    } else if (tab === 'mois') {
      finalMois = selectedMonth;
      finalAnnee = selectedYear;
    } else if (tab === 'annee') {
      finalAnnee = selectedYear;
    }

    window.currentEtatClientId = id;
    window.currentEtatType = 'client';
    window.currentEtatFilterType = finalFilterType;
    window.currentEtatDate = finalDate;
    window.currentEtatDateDebut = finalDateDebut;
    window.currentEtatDateFin = finalDateFin;
    window.currentEtatMois = finalMois;
    window.currentEtatAnnee = finalAnnee;

    setShowModal(true);
  };

  const modalFilterType =
    tab === 'jour' && jourMode === 'date'
      ? 'jour'
      : tab === 'jour' && jourMode === 'periode'
        ? 'periode'
        : tab;

  const clientLabel = client
    ? `${client.nom || ''}${client.prenom ? ` ${client.prenom}` : ''}`.trim()
    : '';

  return (
    <CgmModulePageLayout
      crumb="Comptabilité clients · État"
      title={clientLabel ? `État client · ${clientLabel}` : 'État client'}
      backTo={`/client/${id}/charges`}
      wide
    >
      {client && (
        <div className="alert alert-light border mb-3" role="status">
          <strong>{client.nom} {client.prenom}</strong>
          {client.telephone ? ` · ${client.telephone}` : ''}
          {client.email ? ` · ${client.email}` : ''}
        </div>
      )}

      <div className="cgm-list-toolbar">
        <div className="cgm-filter-panel cgm-period-panel">
          <div className="cgm-filter-panel__title">Filtrer l&apos;état client</div>
          <div className="cgm-period-body">
            <div className="cgm-period-tabs">
              <button type="button" className={`cgm-period-tab ${tab === 'jour' ? 'active' : ''}`} onClick={() => setTab('jour')}>Jour</button>
              <button type="button" className={`cgm-period-tab ${tab === 'mois' ? 'active' : ''}`} onClick={() => setTab('mois')}>Mois</button>
              <button type="button" className={`cgm-period-tab ${tab === 'annee' ? 'active' : ''}`} onClick={() => setTab('annee')}>Année</button>
            </div>

            {tab === 'jour' && (
              <div className="cgm-period-jour-panel">
                <div className="cgm-period-mode-group" role="group" aria-label="Mode jour">
                  <div className="form-check">
                    <input className="form-check-input" type="radio" id="etatCliJourDate" name="etatCliJourMode" checked={jourMode === 'date'} onChange={() => setJourMode('date')} />
                    <label className="form-check-label" htmlFor="etatCliJourDate">Par date</label>
                  </div>
                  <div className="form-check">
                    <input className="form-check-input" type="radio" id="etatCliJourPeriode" name="etatCliJourMode" checked={jourMode === 'periode'} onChange={() => setJourMode('periode')} />
                    <label className="form-check-label" htmlFor="etatCliJourPeriode">Par période</label>
                  </div>
                </div>
                <div className="cgm-period-filter-row">
                  {jourMode === 'date' ? (
                    <>
                      <label className="mb-0">Date</label>
                      <input type="date" className="hono-input-date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
                    </>
                  ) : (
                    <>
                      <label className="mb-0">De</label>
                      <input type="date" className="hono-input-date" value={dateDebut} onChange={(e) => setDateDebut(e.target.value)} />
                      <label className="mb-0">à</label>
                      <input type="date" className="hono-input-date" value={dateFin} onChange={(e) => setDateFin(e.target.value)} />
                    </>
                  )}
                </div>
              </div>
            )}

            {tab === 'mois' && (
              <div className="cgm-period-filter-row">
                <label className="mb-0">Mois</label>
                <select className="hono-select-month" value={selectedMonth} onChange={(e) => setSelectedMonth(parseInt(e.target.value, 10))}>
                  {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                    <option key={m} value={m}>{String(m).padStart(2, '0')}</option>
                  ))}
                </select>
                <label className="mb-0">Année</label>
                <select className="hono-select-year" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}>
                  {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
            )}

            {tab === 'annee' && (
              <div className="cgm-period-filter-row">
                <label className="mb-0">Année</label>
                <select className="hono-select-year" value={selectedYear} onChange={(e) => setSelectedYear(parseInt(e.target.value, 10))}>
                  {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="cgm-period-actions">
              <button type="button" className="cgm-toolbar-btn cgm-toolbar-btn--primary" onClick={handleShowEtat}>
                Rechercher
              </button>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <EtatCgmModal
          show={showModal}
          onClose={() => setShowModal(false)}
          type="client"
          filterType={modalFilterType}
          date={tab === 'jour' && jourMode === 'date' ? selectedDate : null}
          dateDebut={tab === 'jour' && jourMode === 'periode' ? dateDebut : null}
          dateFin={tab === 'jour' && jourMode === 'periode' ? dateFin : null}
          mois={tab === 'mois' ? selectedMonth : null}
          annee={tab === 'mois' || tab === 'annee' ? selectedYear : null}
        />
      )}
    </CgmModulePageLayout>
  );
}
